export enum StyleEnum {
    BIG = 'big_numbers',
    NORMAL = 'normal',
}
